import { render, staticRenderFns } from "./ItemPopShop.vue?vue&type=template&id=9ba41e84&scoped=true&"
import script from "./ItemPopShop.vue?vue&type=script&lang=js&"
export * from "./ItemPopShop.vue?vue&type=script&lang=js&"
import style0 from "./ItemPopShop.vue?vue&type=style&index=0&id=9ba41e84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba41e84",
  null
  
)

export default component.exports